<template>
  <div>
    <wc-data-box
      title='Contact Info'
      titleIcon='mdi-card-account-mail'
      titleIconColor='orange'
      showEdit
      showHelp
      :helpText='helpText'
      @edit='editDetails'
    >
      <wc-two-column-table
        :items='details'
        @rowClick='editDetails'
      ></wc-two-column-table>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      title='Contact info'
      icon='mdi-card-account-mail'
      iconColor='orange'
      :disableButtons='!isFormValid'
      @cancel='showDialog = false'
      @save='save'
    >
      <v-form v-model='isFormValid' ref='form'>
        <details-form v-model='divisionCopy'></details-form>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import ContactDetailsForm from '../../components/forms/ContactDetailsForm'
import _ from 'lodash'

export default {
  name: 'division-contact-details',
  props: {
    division: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    divisionCopy: {},
    showDialog: false
  }),
  computed: {
    header () {
      return this.$store.state.icons.dataBox.address
    },
    details () {
      let table = [
        { text: 'Address', value: this.division.address },
        { text: 'City', value: this.division.city },
        { text: 'Postal code', value: this.division.postal_code },
        { text: 'Province', value: this.division.province },
        { text: 'Country', value: this.division.country },
        { text: 'AR Email', value: this.division.ar_email },
        { text: 'Phone', value: this.division.phone },
        { text: 'Website', value: this.division.website }
      ]
      return table
    },
    helpText () {
      return `
        This information will be presented on invoices for customers so they know where to send payments.
      `
    }
  },
  methods: {
    editDetails () {
      this.divisionCopy = _.cloneDeep(this.division)
      this.showDialog = true
    },
    save () {
      this.$emit('update', this.divisionCopy)
      this.showDialog = false
    }
  },
  components: {
    'details-form': ContactDetailsForm
  }
}
</script>
